<template>
  <div class="vendor-list-container">
    <div class="vendor-list row">
      <div
        class="item-wrapper col-12 col-md-4 "
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="vendor-item p-3" @click="navigateTo(item)">
          <div class="top">
            <p class="name mb-0">{{ item.companyName }}<span> ></span></p>
            <div class="location">
              <img
                src="@/assets/images/icon_location.png"
                class="icon mr-2"
                alt=""
              />
              <span class="text-truncate">{{
                item.city && item.city.name
              }}</span>
            </div>
          </div>
          <div class="middle">
            <img
              :src="`${baseUrl}/uploadFile/pictureView.htm?id=${item.logoId}`"
              class="icon"
              alt=""
            />
            <div class="right">
              <p class="slogan mb-0 text-truncate">
                {{ item.companyIntroduce }}
              </p>
              <div class="score">
                <span>评价：</span>
                <stars class="star-icon" :score="item.star"></stars>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div
              class="tag"
              v-for="(tag, i) in item.goodField.split('、')"
              :key="i"
            >
              {{ tag }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination" v-if="isShowPagination">
      <button
        class="pagination-button mr-5"
        v-if="hasLast"
        @click.prevent.stop="last"
      >
        上一页
      </button>
      <button
        class="pagination-button"
        v-if="hasNext"
        @click.prevent.stop="next"
      >
        下一页
      </button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.vendor-list-container {
  .vendor-list {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    .vendor-item {
      // width: 28.25vw;
      height: 14.5rem;
      border: solid 0.06rem #e5e5e5;
      margin-bottom: 3.6rem;
      text-align: left;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &:hover {
        cursor: pointer;
      }
      .top {
        display: flex;
        justify-content: space-between;

        .name {
          font-size: 1.38rem;
          color: #333333;
          span {
            color: #999;
          }
        }
        .location {
          white-space: nowrap;
          .icon {
            vertical-align: middle;
          }
          span {
            vertical-align: middle;
            font-size: 1.25rem;
            color: #999999;
          }
        }
      }
      .middle {
        display: flex;
        .icon {
          width: 5.44rem;
          height: 5.44rem;
          margin-right: 1rem;
          flex-shrink: 0;
        }
        .right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          overflow: hidden;

          .slogan {
            font-size: 1.25rem;
            color: #666666;
          }
          .score {
            span {
              font-size: 1.25rem;
              color: #333333;
              vertical-align: middle;
              // margin-right: 0.5rem;
            }
            .star-icon {
              vertical-align: middle;
              display: inline-block;
            }
          }
        }
      }
      .bottom {
        .tag {
          padding: 0.25rem 0.5rem;
          display: inline-block;
          border: solid 0.06rem #e5e5e5;
          margin-right: 1rem;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .pagination {
    margin-bottom: 3rem;
    display: flex;
    justify-content: center;
    .pagination-button {
      padding: 0 15px;
      padding: 0.5rem 1.5rem;
      background-color: $acentColor;
      color: white;
      border: none;
      outline: none;
      font-size: 1rem;
      border-radius: 0.25rem;
      &:hover {
        background-color: rgba($color: $acentColor, $alpha: 0.9);
      }
      &:active {
        background-color: #771610;
      }
    }
  }
}
</style>

<script>
import Stars from '@/components/Stars';
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    isShowPagination: {
      type: Boolean,
      default: false
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    hasLast: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      vendorList: Array(9).fill({
        name: '博彦新光科技',
        slogan: '我们拥有自己的团队，可以对您的需求进行个性化开发',
        score: 4,
        location: '北京',
        tags: ['前端开发', '网站UI设计', 'LOGO设计', 'VI设计']
      })
    };
  },
  components: {
    Stars
  },
  methods: {
    navigateTo(vendor) {
      this.$router.push({
        name: 'vendorDetail',
        query: { name: vendor.companyName, id: vendor.id }
      });
    },
    next() {
      this.$emit('next');
    },
    last() {
      this.$emit('last');
    }
  }
};
</script>
